module.exports = __webpack_public_path__ + "img/symbol_4.ca3fc4d1.png";